<template>
  <div class="loyalty-widget" v-if="showWidget && isApiSettled && nxgLoyalty">
    <div class="loyalty-widget-top">
      <div>
        <lazy-image
          :class="isUserEnrolled ? 'loy-img-big' : 'loy-img-small'"
          alt="cheesy image"
          :src="loyaltyLogo"
          :src-placeholder="getPlaceHolderImg"
          loading="lazy"
        />
      </div>
      <div class="loyalty-texts">
        <span
          class="bold"
          :class="[isUserEnrolled ? 'fs-16' : 'fs-14']"
          v-if="getTitle"
          >{{ getTitle }}</span
        >
        <div class="d-flex flex-column" v-if="!isUserEnrolled">
          <span>{{ getSubtitle1 }}</span>
          <span>{{ getSubtitle2 }}</span>
        </div>
        <span
          class="color-primary bold fs-14 pt12"
          v-if="isUserEnrolled"
          @click="handleCtaClick"
          >{{ getCta }}</span
        >
      </div>
    </div>
    <div class="enroll-section mt24" v-if="!isUserEnrolled">
      <button class="line-btn enroll-cta-widget" @click="handleEnrollBtnClick">
        {{ enrollCta }}
      </button>
      <div class="tnc-text pt10" @click="handleTncBtnClick">
        {{ tncText }}<span class="tnc-cta">{{ tncCta }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from "../../LazyImage.vue";
import { keyMapsGetter } from "../../../helpers/storeKeys";
import { staticImgBaseUrl } from "../../../config/apiEndpoints";
import Utility from "../../../helpers/utility.js";
import LocalStorageFunc from "../../../helpers/localStorageFunc";
import setEvents from "../../../helpers/events";
import PageNames from "../../../config/pageNames";

export default {
  name: "LoyaltyWidget",
  props: ["moduleProps"],
  components: {
    LazyImage,
  },
  data() {
    return {
      modulePropsData: {},
      enrollModal: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: ``,
      },
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    eventFunction(eventType = "", eObj = {}) {
      const eventObj = Utility.amplitudeEventObj(
        eObj.userAction,
        eObj.sectionName,
        undefined,
        eObj,
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleEnrollBtnClick(event) {
      const eventData = {
        screenName: PageNames.NEXTGEN_HOMEPAGE,
        previousScreenname: "",
        sectionName: "Enroll 2X Loyalty",
        category: "Enroll now click",
      };
      this.eventFunction("Click", eventData);
      this.eventFunction("ClickEnroll", eventData);
      Utility.sendToLoyaltyScreen();
    },
    handleTncBtnClick() {
      const eventData = {
        screenName: PageNames.NEXTGEN_HOMEPAGE,
        previousScreenname: "",
        sectionName: "Enroll 2X Loyalty",
        category: "terms and conditions click",
      };
      this.eventFunction("Click", eventData);
      LocalStorageFunc.setLoyTnc(true);
      Utility.sendToLoyaltyScreen();
    },
    handleCtaClick() {
      if (this.loyaltyPoints < 200) {
        const eventData = {
          screenName: PageNames.NEXTGEN_HOMEPAGE,
          previousScreenname: "",
          sectionName: "Enroll 2X Loyalty",
          category: "Order Now",
        };
        this.eventFunction("Click", eventData);
        Utility.sendToMenuScreen();
      } else {
        const eventData = {
          screenName: PageNames.NEXTGEN_HOMEPAGE,
          previousScreenname: "",
          sectionName: "Enroll 2X Loyalty",
          category: "Redeem now",
        };
        this.eventFunction("Click", eventData);
        Utility.sendToLoyaltyScreen();
      }
    },
  },
  computed: {
    loyaltyLogo() {
      return this.modulePropsData?.loyaltyLogo || "";
    },
    enrollCta() {
      return this.modulePropsData?.enrollCta || "";
    },
    redeemCta() {
      return this.modulePropsData?.redeemCta || "";
    },
    orderCta() {
      return this.modulePropsData?.orderCta || "";
    },
    subtitle1() {
      return this.modulePropsData?.subtitle1 || "";
    },
    subtitle2() {
      return this.modulePropsData?.subTitle2 || "";
    },
    titleNotEnrolled() {
      return this.modulePropsData?.titleNotEnrolled || "";
    },
    titleEnrolledNoPoints() {
      return this.modulePropsData?.titleEnrolledNoPoints || "";
    },
    titleEnrolledPoints() {
      return this.modulePropsData?.titleEnrolledPoints || "";
    },
    tncText() {
      return this.modulePropsData?.tncText || "";
    },
    tncCta() {
      return this.modulePropsData?.tncCta || "";
    },
    enrollSuccessLogo() {
      return this.modulePropsData?.enrollSuccessLogo || "";
    },
    rewardsSuccessTitle() {
      return this.modulePropsData?.rewardsSuccessTitle || "";
    },
    rewardsSuccessSubTitle() {
      return this.modulePropsData?.rewardsSuccessSubTitle || "";
    },
    rewardsSuccessCta() {
      return this.modulePropsData?.rewardsSuccessCta || "";
    },
    enrollingNowText() {
      return this.modulePropsData?.enrollingNowText || "";
    },
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.rect;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
    isUserEnrolled() {
      return this.$store.state.User.isUserEnrolledForLoyalty;
    },
    loyaltyPoints() {
      return this.$store.getters[keyMapsGetter.GET_USER_LOYALTY_POINTS] || 0;
    },
    getTitle() {
      if (!this.isUserEnrolled) {
        return this.titleNotEnrolled;
      } else if (!this.loyaltyPoints) {
        return this.titleEnrolledNoPoints;
      } else {
        return this.titleEnrolledPoints;
      }
    },
    getCta() {
      if (this.loyaltyPoints < 200) {
        return this.orderCta;
      } else return this.redeemCta;
    },
    getSubtitle1() {
      let points = this.is2xUser ? "200" : "100";
      return (this.subtitle1 || "").replace("###", points);
    },
    getSubtitle2() {
      const points = this.redeemPointsSlab?.join(", ") || "600";
      return (this.subtitle2 || "").replace("###", points);
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    is2xUser() {
      return this.$store.state.Loyalty.is2xUser;
    },
    redeemPointsSlab() {
      return this.$store.state.Loyalty.redeemPointsSlab;
    },
    isApiSettled() {
      const loyaltyApi = this.$store.state.User?.isUserLoyaltyApiSettled;
      const walletBallanceApi =
        this.$store.state.User?.isWalletBallanceApiSettled;
      if (loyaltyApi && walletBallanceApi) {
        return true;
      } else {
        return false;
      }
    },
    showWidget() {
      if (!this.isLoggedIn) return false;
      if (!this.isUserEnrolled) return true;
      if (!this.loyaltyPoints) return true;
      const minRedeemPoints = this.redeemPointsSlab?.[0];
      return this.loyaltyPoints >= minRedeemPoints || this.loyaltyPoints >= 600;
    },
    nxgLoyalty() {
      const data = this.$store?.state?.Config?.appConfig?.config || "";
      const asset = window?._siteProps_?.platform;
      if (!data || !asset) {
        return false;
      } else {
        const flag =
          data &&
          data?.nxgLoyalty
            ?.split(",")
            ?.some((item) => item.toLowerCase() === asset.toLowerCase());
        return flag;
      }
    },
  },
};
</script>

<style scoped></style>
